<template>
  <ul class="find-nav-list">
    <li class="find-nav-item" v-for="(item, index) in list" :key="index" @click="handlePush(item)">
      <img class="logo" :src="item.logo" />
      <p class="title">{{ item.text }}</p>
    </li>
  </ul>
</template>

<script>
import {dictGetByType} from '@/api/dd'
export default {
  name: 'nav',
  data() {
    return {
      list: []
    }
  },
  methods: {
    handlePush(item) {
      this.$router.push(`/type/${item.code}?title=${item.text}`)
    },
    handleGetStage() {
      dictGetByType({type: 'stage'}).then(res => {
        const data = res.data
        this.list = data.filter(item => {
          return item.isSystem === true
        })
        this.list = this.list.slice(0, 5)
        this.list = this.list.map((item, index) => {
          item.logo = require(`@/assets/image/Frame${index + 1}.png`)
          return item
        })
        console.log(this.list.slice(0, 5))
      })
    }
  },
  mounted() {
    this.handleGetStage()
  }
}
</script>

<style lang="scss" scoped>
.find-nav-list {
  margin-top: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .find-nav-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;
    flex: 0 0 18%;
    width: 18%;
    height: 80px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0px 0px 24px 0px rgba(23, 38, 71, 0.04);
    .logo {
      width: 28px;
      height: 28px;
    }
    .title {
      margin-top: 12px;
      font-size: 12px;
      font-weight: 500;
      color: #303133;
    }
  }
}
</style>
